module.exports = __webpack_public_path__ + "img/symbol_7.88706349.png";